// extracted by mini-css-extract-plugin
export default {"Overlay":"K2JHsQ3Z","FloatingOverlay":"M0cjKKWa","OverlayContainer":"peC9485p","OverlayContainerContent":"EaDq6wvf","OverlaySurface":"ZkkWF1Nr"};